import { Fragment, useContext } from "react";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules';
import { Data, List, portfolio, portfolioMo } from 'data/portfolio'
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "App";
import 'swiper/css';
import 'swiper/css/pagination';
import './style.css'

const PortfolioSwiper = ({ init }: any) => {
    const navigate = useNavigate()
    const { isTablet } = useContext(GlobalContext)

    const goDetail = (id: number) => {
        navigate({
            pathname: '/portfolioDetail',
            search: `?id=${id}`,
        });
        window.scrollTo(0, 0);
        init(String(id));
    }

    return (
        <Fragment>
            <Swiper
                slidesPerView={isTablet ? 2 : 1}
                spaceBetween={10}
                modules={[Pagination]}
                pagination={{ // 페이지네이션 활성화
                    clickable: true, // 페이지네이션 버튼 클릭 가능하게 할지 말지
                }}
            >
                {
                    isTablet ?
                        portfolioMo.map((item: List, idx: number) => (
                            <SwiperSlide key={idx}>
                                <div
                                    onClick={() => goDetail(item.id)}
                                    key={idx}
                                    style={{
                                        backgroundImage: `url(${item.background})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: '100%',
                                        height: '45vw',
                                    }}
                                    className="flex justify-center items-center rounded-xl w-full font-bold text-white cursor-pointer select-none">
                                    <div className='flex flex-col justify-center items-center gap-4 bg-[rgba(0,0,0,0.4)] rounded-xl w-full h-full'>
                                        {
                                            item.logo &&
                                            <item.logo className="w-16 h-16" />
                                        }
                                        <div className='flex flex-col items-center'>
                                            <p className='text-sm'>{item.name}</p>
                                            <p className='text-sm'>{item.period}</p>
                                            <p className="text-xs">{item.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )) :
                        portfolio.map((item: Data, index) => (
                            <SwiperSlide key={index}>
                                <div className="gap-4 grid grid-cols-4 grid-rows-1">
                                    {item.data.map((items: List, idx: number) => (
                                        <div
                                            onClick={() => goDetail(items.id)}
                                            key={idx}
                                            style={{
                                                backgroundImage: `url(${items.background})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat',
                                                width: '100%',
                                                height: '30vh',
                                            }}
                                            className="group flex justify-center items-center rounded-xl w-full font-bold text-white cursor-pointer select-none"
                                        >
                                            <div className='flex flex-col justify-center items-center gap-6 bg-[rgba(0,0,0,0.8)] opacity-0 group-hover:opacity-100 rounded-xl w-full h-full transition-opacity duration-300'>
                                                {
                                                    items.logo &&
                                                    <items.logo />
                                                }
                                                <div className='flex flex-col items-center'>
                                                    <p>{items.name}</p>
                                                    <p>{items.period}</p>
                                                </div>
                                                <p>{items.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </SwiperSlide>
                        ))
                }
            </Swiper>
        </Fragment>
    );
}

export default PortfolioSwiper;

